import { WebGLRenderTarget, ShaderMaterial } from 'three'
import { useEffect, useMemo, useRef } from 'react'
import { extend, useFrame, useThree } from 'react-three-fiber'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'

// import { RadialBlurShader } from '../../shaders/RadialBlurShader'
// import { GaussianBlurShader } from '../../shaders/GaussianBlurShader'

extend({ EffectComposer, ShaderPass, RenderPass })

export const NoiseEffect = () => {
  const { gl, scene, camera, size } = useThree()

  const noiseShader = useRef(
    new ShaderPass(
      new ShaderMaterial({
        uniforms: {
          tDiffuse: { value: null },
          amount: { value: 0 }
        },
        vertexShader: `
          varying vec2 vUv;
          void main() {
          vUv = uv;
          gl_Position = projectionMatrix 
              * modelViewMatrix 
              * vec4( position, 1.0 );
          }
      `,
        fragmentShader: `
          uniform float amount;
          uniform sampler2D tDiffuse;
          varying vec2 vUv;
      
          float random( vec2 p )
          {
          vec2 K1 = vec2(
              23.14069263277926, // e^pi (Gelfond's constant)
              2.665144142690225 // 2^sqrt(2) (Gelfondâ€“Schneider constant)
          );
          return fract( cos( dot(p,K1) ) * 12345.6789 );
          }
      
          void main() {
      
          vec4 color = texture2D( tDiffuse, vUv );
          vec2 uvRandom = vUv;
          uvRandom.y *= random(vec2(uvRandom.y,amount));
          color.rgb += random(uvRandom)*0.05;
          gl_FragColor = vec4( color  );
          }
      `
      })
    )
  )

  const [base, final] = useMemo(() => {
    const renderScene = new RenderPass(scene, camera)
    const offscreenTarget = new WebGLRenderTarget(size.width, size.height)

    const comp = new EffectComposer(gl, offscreenTarget)
    comp.renderToScreen = false
    comp.addPass(renderScene)

    const finalComposer = new EffectComposer(gl)
    // const radialBlurShader = new RadialBlurShader()
    // radialBlurShader.uniforms.strength.value = 0.08
    // const radialPass = new ShaderPass(radialBlurShader)
    // const finalPass = new ShaderPass(new GaussianBlurShader())
    // finalPass.needsSwap = true;
    finalComposer.addPass(renderScene)
    finalComposer.addPass(noiseShader.current)
    // finalComposer.addPass(finalPass)
    /* const fxaa = new ShaderPass(FXAAShader)
      fxaa.material.uniforms['resolution'].value.x = 1 / size.width
      fxaa.material.uniforms['resolution'].value.y = 1 / size.height
      finalComposer.addPass(fxaa) */
    return [comp, finalComposer]
  }, [])

  useEffect(() => {
    base.setSize(size.width, size.height)
    final.setSize(size.width, size.height)
  }, [base, final, size])

  useFrame(state => {
    noiseShader.current.material.uniforms.amount.value = state.clock.getElapsedTime()

    base.render()
    final.render()
  }, 1)

  return null
}
